import { OTA_Source } from "./ota_source.model";

export class OTA_POS {
    public source = new OTA_Source();
}
